module.exports = __webpack_public_path__ + "media/Credits.c3614f8a.mp3";